import React from 'react';
import { Box } from '@mui/material';

import PostDescription from '../../../../DesignSystem/PostDescription';
import PublicationAlert from '../../../Shared/PublicationAlert';
import { isPostPublished } from '../../../../../Utils/Post';
import useWidth from '../../../../../Hooks/useWidth';
import VideoEmbed from '../../../../DesignSystem/VideoEmbed';
import AttachmentLinksList from '../../../Shared/AttachmentLinksList';
import SubContent from '../SubContent/SubContent';
import useSpace from '../../../../../Hooks/useSpace';

function FolderShow({ post }: any) {
  const { space } = useSpace();
  const isMobile = useWidth('down', 'sm');
  const isPublished = isPostPublished(post);

  return (
    <>
      {!isPublished && (
        <Box sx={{ mb: 3 }}>
          <PublicationAlert askToPublishAt={post.ask_to_publish_at} />
        </Box>
      )}

      <Box sx={{ mb: 3 }}>
        <PostDescription content={post.content} readMore />
        <AttachmentLinksList attachments={post.attachments} />
      </Box>

      {post.video_embed && (
        <Box sx={{ mb: 3, width: isMobile ? '100%' : '60%' }}>
          <VideoEmbed title={post.title} src={post.video_embed} />
        </Box>
      )}

      <Box sx={{ mt: 4 }}>
        <SubContent post={post} space={space} />
      </Box>
    </>
  );
}

export default FolderShow;
